fx.ns("models", class FacebookPhotoModel extends fx.Model {

	constructor(data)
	{
		super(data);
	}

	get defaults()
	{
		return {
			selected: false
		}
	}

	select()
	{
		this.selected = !this.selected;
	}
	
	unSelect()
	{
		//console.log("Unselected")
		// this.selected = false;
	}

});